<template>
  <div class="agreement">
    <div class="agreement_nei">
      <div class="left">
        <leftTemplate4 :left_tabShow="ccc" @back="back"></leftTemplate4>
      </div>
      <div class="right">
        <div v-html="cccContent">
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { Axios } from "../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
import leftTemplate4 from "@/components/leftTemplate4.vue";
const ccc = ref('')
const cccContent = ref('')
onMounted(() => {
  ccc.value = decodeURI(window.location.href.split('=')[1])
  init()
})
const init = () => {
  Axios("get", `/system/notice/bycode/${ccc.value}`, {}, false, function (res) {
    if (res.data.code == 200) {
      cccContent.value = res.data.data.noticeContent
    } else {
      ElMessage.error(res.data.message);
    }
  });
}
const back = (val) => {
  ccc.value = val
  init()
}
</script>

<style scoped>
.agreement {
  background-color: #f5f5f5;
}

.agreement_nei {
  width: 12.8rem;
  margin: 0 auto;
  margin-top: 0.7rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.left {
  flex: none;
  width: 1.6rem;
  background: #fff;
  margin-right: 0.4rem;
  min-height: 5.83rem;
  margin-top: 0.3rem;
  margin-bottom: 0.24rem;
  border-radius: 0.18rem;
  min-width: 1.6rem;
  box-sizing: border-box;
}

.right {
  flex: none;
  width: calc(100% - 1.6rem);
  min-width: 10.8rem;
  background: #fff;
  min-height: 5.83rem;
  margin-top: 0.3rem;
  margin-bottom: 0.24rem;
  border-radius: 0.18rem;
  padding: 0.24rem;
  box-sizing: border-box;
  overflow: hidden;
}
</style>
